var map = {
	"./april.png": 2649,
	"./august.png": 2650,
	"./autumn.png": 2651,
	"./christmas.png": 2652,
	"./december.png": 2653,
	"./easter.png": 2654,
	"./february.png": 2655,
	"./january.png": 2656,
	"./july.png": 2657,
	"./june.png": 2658,
	"./march.png": 2659,
	"./may.png": 2660,
	"./midsummer.png": 2661,
	"./new_year.png": 2662,
	"./november.png": 2663,
	"./november_11.png": 2664,
	"./november_18.png": 2665,
	"./october.png": 2666,
	"./september.png": 2667,
	"./september_1.png": 2668,
	"./spring.png": 2669,
	"./summer.png": 2670,
	"./valentine_day.png": 2671,
	"./winter.png": 2672
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2648;